import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { requestCategoryService } from "../services/requestCategory.service";

export const useDeleteRequestCategory = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (categoryId: string) => requestCategoryService.deleteRequestCategory(categoryId),
    onSuccess: () => {
      // Invalidate request categories query to refetch the updated list
      queryClient.invalidateQueries({ queryKey: ["requestCategories"] });
      toast.success("Category deleted", { duration: 2000 });
    },
    onError: (error) => {
      console.error("Failed to delete category:", error);
      toast.error("Failed to delete category", { duration: 2000 });
    },
  });
};
